export const START_LOAD = 'user/START_LOAD';
export const FINISH_LOAD = 'user/FINISH_LOAD';

const initialState = {
    loading:false,
    user:null
};
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case START_LOAD:  return {...state, loading:true};
        case FINISH_LOAD:  return {...state, loading:false, user:action.payload};
        default: return state;
    }
}